import * as angular from 'angular';

import { SelectionStrategy, ComponentDefinition } from '../../models';
import { ValidationValueTypes } from '../../common/ValidationValueTypes';

class ValueTypeSelectorController implements angular.IComponentController {
    isLoading: boolean;
    loadingMessage: string;
    model: string;
    strategy: SelectionStrategy;
    valueTypes: { [strategy: number]: { key: string; value: string; }[]; };

    static $inject = [];
    
    $onInit() {
        this.valueTypes = ValidationValueTypes;
    }
}

export const wtValueTypeSelector: ComponentDefinition = {
    componentId: 'wtValueTypeSelector',
    controller: ValueTypeSelectorController,
    template: require('./valueTypeSelector.component.html'),
    controllerAs: 'vm',
    bindings: {
        isRequired: '<?',
        model: '=',
        name: '@?',
        strategy: '<'
    }
};
